import { render } from "./QywxOrderDetailSaas.vue?vue&type=template&id=480c6370&scoped=true"
import script from "./QywxOrderDetailSaas.vue?vue&type=script&lang=js"
export * from "./QywxOrderDetailSaas.vue?vue&type=script&lang=js"

import "./QywxOrderDetailSaas.vue?vue&type=style&index=0&id=480c6370&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480c6370"],['__file',"src/views/h5/common/plat/qywxOrder/QywxOrderDetailSaas.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "480c6370"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('480c6370', __exports__)) {
    api.reload('480c6370', __exports__)
  }
  
  module.hot.accept("./QywxOrderDetailSaas.vue?vue&type=template&id=480c6370&scoped=true", () => {
    api.rerender('480c6370', render)
  })

}


export default __exports__